import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setNotificationState } from '../redux/notificationsReducer'

import styled from 'styled-components'

import {
  StyledPopup,
  ModalHeader,
  ModalContentWrapper,
  ModalContent,
  CloseBtn,
  Actions,
  CancelBtn,
  SubmitBtnModal,
} from './CommonStylesForms'

import { AttributeRow } from './CommonStylesTables'

const BulkModal = styled.div`
  overflow: auto;
  margin: auto;
  padding: 5px;
  max-height: 90vh;
  font-size: 1em;
  border: 1px solid #d7d7d7;
  background: ${(props) => props.theme.background_primary};
`

const ModalDataCell = styled.td`
  color: ${(props) => props.theme.text_color};
  padding: 8px 8px;
  font-size: 1.2em;
  text-align: left;
`

const ModalInputField = styled.input`
  color: ${(props) => props.theme.text_color};  
  height: 30px;
  font-size: 0.95em; 
  }
`

const BulkModalLabel = styled.label`
  color: ${(props) => props.theme.text_color};
  font-size: 1em;
  width: 30%;
  margin-right: 10px;
`

function FormBulkCredentialsTemplate(props) {
  const dispatch = useDispatch()
  const schemasState = useSelector((state) => state.schemas)
  const bulkTemplateForm = useRef(null)

  const generateCSV = (data) => {
    const headers = Object.keys(data[0]) //(RomanStepanyan) Dynamically get headers from the first data object
    const csvContent = [
      headers.join(','), //(RomanStepanyan) Add headers as the first row
      ...data.map((row) => headers.map((header) => row[header]).join(',')), // Add data rows
    ].join('\n')

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'template.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // (eldersonar) Check for the public DID
    if (schemasState.issuerDID) {
      const form = new FormData(bulkTemplateForm.current)
      const data = [{ email: 'replaceme@example.com' }]

      form.forEach((value, key) => {
        if (key === 'time_to_accept') {
          const days = parseInt(value, 10) //(RomanStepanyan) Parse the input value as an integer
          if (!isNaN(days)) {
            const milliseconds = days * 86400000 //(RomanStepanyan) Convert days to milliseconds
            data[0][key] = milliseconds
          }
        } else if (key === 'schema_id') {
          data[0][key] = value
        } else {
          data[0][key] = ''
        }
      })

      if (data[0].time_to_accept === undefined) {
        dispatch(
          setNotificationState({
            message: 'Error: Time to accept is required.',
            type: 'error',
          })
        )
        return
      } else {
        generateCSV(data)
        props.closeBulkCredModal()
      }
    } else {
      dispatch(
        setNotificationState({
          message: "Error: Public DID not set. Invitation can't be sent.",
          type: 'error',
        })
      )
    }
  }

  function closeBulkCredModal() {
    props.closeBulkCredModal()
  }

  const validSchemas = props.templateShema.filter(
    (schema) => schema !== undefined
  )

  const schemaAttributes = validSchemas.map((schema) => {
    return schema.attribute_names.map((attribute, index) => {
      return (
        <AttributeRow key={attribute}>
          <ModalDataCell>
            <BulkModalLabel htmlFor="schema-attr">
              Attribute {index + 1} :{' '}
            </BulkModalLabel>
          </ModalDataCell>
          <ModalDataCell>
            <input type="hidden" name={attribute} value={attribute || ''} />
            {attribute.replaceAll('_', ' ')}
          </ModalDataCell>
        </AttributeRow>
      )
    })
  })

  return (
    <StyledPopup
      open={props.bulkCredModalIsOpen}
      closeOnDocumentClick
      onClose={closeBulkCredModal}
    >
      <BulkModal>
        <ModalHeader>Create a CSV Template File</ModalHeader>
        <ModalContentWrapper>
          <ModalContent>
            <form onSubmit={handleSubmit} ref={bulkTemplateForm}>
              <table>
                <tbody>
                  <AttributeRow>
                    <ModalDataCell>
                      <BulkModalLabel htmlFor="schema_id">
                        Schema ID
                      </BulkModalLabel>
                    </ModalDataCell>
                    <ModalDataCell>
                      <input
                        type="hidden"
                        name="schema_id"
                        value={validSchemas[0]?.schema_id || ''}
                      />
                      {validSchemas[0]?.schema_id || ''}
                    </ModalDataCell>
                  </AttributeRow>
                  <AttributeRow>
                    <ModalDataCell>
                      <BulkModalLabel htmlFor="time_to_accept">
                        Time to accept the credential (in days)
                      </BulkModalLabel>
                    </ModalDataCell>
                    <ModalDataCell>
                      <ModalInputField
                        required
                        type="number"
                        id="time_to_accept"
                        name="time_to_accept"
                        placeholder="Enter number of days"
                        min="1"
                      />
                    </ModalDataCell>
                  </AttributeRow>
                  {schemaAttributes && schemaAttributes}
                </tbody>
              </table>
              <Actions>
                <CancelBtn
                  type="button"
                  onClick={closeBulkCredModal}
                  id="button-cancel"
                >
                  Cancel
                </CancelBtn>
                <SubmitBtnModal type="submit" id="button-send">
                  Create
                </SubmitBtnModal>
              </Actions>
            </form>
          </ModalContent>
        </ModalContentWrapper>
        <CloseBtn onClick={closeBulkCredModal} id="button-exit">
          &times;
        </CloseBtn>
      </BulkModal>
    </StyledPopup>
  )
}

export default FormBulkCredentialsTemplate
